<template>
  <div class="index-box">
    <div class="index-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length>0?'没有更多了':'暂无数据'"
        @load="onLoad"
      >

        <a v-for="item in list" :key="item.noticeId" class="item-box" :href="'/content/noticeDetail?id='+item.noticeId">
          <h3 class="ovDna">{{item.title}}</h3>
          <div>
            <span :class="{active:!item.readStatus}">{{!item.readStatus?'未读':'已读'}}</span>
            <b>{{item.time}}</b>
          </div>
        </a>
      </van-list>
    </div>
    <bottomNav :navIndex="navIndex"/>
  </div>
</template>

<script>
  import bottomNav from '../components/Nav'
  export default {
    name: "NoticeList",
    data(){
      return {
        navIndex:1,
        list: [],          // 职位列表
        loading: false,     // 列表加载中
        finished: false,    //  列表加载完显示
        page: 1,           //   当前页数
        pageTotal: 1,       //   总页数
      }
    },
    created() {
    },
    methods:{
      //  获取首页列表
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          this.$api.apiContent.noticeList({
            token: this.$store.state.user.token,
            pageNume: 1,
            pageSize: 1000
          }).then(res => {
            // 加载状态结束
            this.loading = false;
            this.finished = true;
            res.row.map(item=>{
              item.createTime = this.$tools.ZHDate(new Date(item.createTime))
            })
            this.list = res.row
          }).catch(e => {
            console.log(e)
          })
        })
      }
    },
    components:{
      bottomNav
    }
  }
</script>

<style scoped lang="scss">
  .index-box{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding:15px 15px 60px;
    background-image: url(../../assets/img/homebg.jpg);
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    /*overflow-y: scroll;*/
    .index-list{
      position: absolute;
      top: 15px;
      left: 15px;
      right: 15px;
      bottom: 60px;
      overflow-y: scroll;
      background: #fff;
      border-radius: 5px;
      padding: 10px;
      a.item-box{
        display: block;
        padding: 10px 0;
        border-bottom: 1px solid #e5e5e5;
        color: #333;
        h3{
          font-size: 20px;
          line-height: 32px;
          color: #333;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #666;
          font-size: 14px;
          span{
            width: 50px;
            height: 21px;
            text-align: center;
            line-height: 21px;
            background: #e5e5e5;
            color: #fff;
            border-radius: 11px;
            font-size: 14px;
            &.active{
              background-color: #e9f5ff;
              color: #2b8ee3;
            }
          }
        }
      }
    }
  }
</style>